export default __webpack_public_path__ + "static/media/support-experts-security.378a8fe1.svg";